import { Switch } from '@mui/joy';

import { TabNavGroup } from '@/components/TabNav/TabNavGroup';

import {
  COMMIT_PROMPT_MESSAGES_ID,
  COMMIT_PROMPT_MODEL_CONFIGURATION_ID,
  COMMIT_PROMPT_TOOLS_ID,
} from './constants';

export const CommitViewHeader = ({
  currentCommitHash,
  showDiff,
  setShowDiff,
  hasTools,
  hasModelConfig,
  hasPreviousCommit,
}: {
  currentCommitHash: string;
  showDiff: boolean;
  setShowDiff: (show: boolean) => void;
  hasTools: boolean;
  hasModelConfig: boolean;
  hasPreviousCommit: boolean;
}) => {
  const tabs = [
    {
      title: 'Messages',
      targetElementId: COMMIT_PROMPT_MESSAGES_ID,
    },
    ...(hasTools
      ? [
          {
            title: 'Tools',
            targetElementId: COMMIT_PROMPT_TOOLS_ID,
          },
        ]
      : []),
    ...(hasModelConfig
      ? [
          {
            title: 'Model Configuration',
            targetElementId: COMMIT_PROMPT_MODEL_CONFIGURATION_ID,
          },
        ]
      : []),
  ];

  const rightContent = (
    <>
      {hasPreviousCommit && (
        <div className="flex flex-row items-center gap-1">
          <span className="text-sm">Show diff</span>
          <Switch
            checked={showDiff}
            onChange={(event) => setShowDiff(event.target.checked)}
            size="sm"
            variant="soft"
          />
        </div>
      )}
    </>
  );

  return (
    <div className="flex flex-row items-center justify-between border-b border-secondary px-4 pb-2">
      <div className="flex flex-row gap-2">
        <span className="my-auto w-[100px] text-xl font-medium">
          {currentCommitHash.slice(0, 8)}
        </span>
        <TabNavGroup defaultTab={COMMIT_PROMPT_MESSAGES_ID} tabs={tabs} />
      </div>
      {rightContent && (
        <div className="flex flex-row items-center gap-2">{rightContent}</div>
      )}
    </div>
  );
};
